import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import http from '../../helpers/http'
import { TrackingProvider } from '../../TrackingContext'
import { Logo } from '../Logo'

import { Box, Card, Spinner } from '@grupoboticario/flora-react'
import ReverseAddresses from './ReverseAddress'
import Divider from '../Divider'
import TrackingID from '../TrackingID'
import Updates from '../Updates'

const Tracking = () => {
  const navigate = useNavigate()
  const { reverseUUID } = useParams()

  const [data, setData] = useState<TTracking | null>(null)
  const [loading, setLoading] = useState(true)

  if (!reverseUUID) navigate('/expirado')

  useEffect(() => {
    if (!reverseUUID) return

    http
      .get<TTracking>(`v1/reverse/detail-tracking/${reverseUUID}`)
      .then(({ data: reverseOrder }) =>
        setData({
          ...reverseOrder,
          orderTraceabilityModel: {
            nmPedidoExpedidor: reverseOrder.dispatcherOrderId,
            salesLogoUrl: reverseOrder.salesImage,
            cadExpedidor: {
              nmExpedidor: reverseOrder.recipient
            },
            orqOcorrenciaFrete: reverseOrder.trackingDtoList.map((track: Record<string, string>) => ({
              dtOcorrencia: track.date,
              nmMensagem: track.message,
              tabSituacaoPedido: {
                nmSituacaoPedido: track.occurrence
              },
              nmObservacao: null
            }))
          }
        })
      )
      .catch(() => navigate('/expirado'))
      .finally(() => {
        setLoading(false)
      })
  }, [reverseUUID])

  return !loading && !!data ? (
    <TrackingProvider data={data}>
      <Logo />
      <Card css={{ width: '100%', marginTop: '20px', padding: '32px', boxShadow: '0px 4px 20px 0px #0000001F' }}>
        <TrackingID />
        <Divider />
        <ReverseAddresses reverseTrackingInfo={data} />
        <Divider />
        <Updates />
      </Card>
    </TrackingProvider>
  ) : (
    <Box css={{ margin: '35vh auto' }}>
      <Spinner label="Loading, please wait." size="md" />
    </Box>
  )
}

export default Tracking
